<template>
  <div>
    <div class="map" id="mapScreen2"></div>
    <div class="openWin" v-show="showFlag">
      <div class="iconBox"><span class="title">{{windowTitle}}</span><i class="el-icon-circle-close" id="close"
                                                                        @click="closeWin()"></i></div>
      <div v-if="flag==1" class="box">
        <p><span class="label">安装位置：</span><span class="value">{{detail.address}}</span></p>
        <p><span class="label">设备状态：</span><span class="value">在线</span></p>
        <p><span class="label">设备电量：</span><span class="value">{{detail.dl}}</span></p>
      </div>
      <div v-if="flag==2" class="box">
        <p><span class="label">使用人：</span><span class="value">{{detail.name}}</span></p>
        <p><span class="label">设备状态：</span><span class="value">在线</span></p>
        <p><span class="label">设备电量：</span><span class="value">{{detail.dl}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
  import img1 from '@/assets/map/rq.png'
  import img2 from '@/assets/map/yg.png'
  import img3 from '@/assets/map/gj.png'

  export default {
    props: {
      latitude: {
        type: [Number],
        default: 31.511953
      },
      longitude: {
        type: [Number],
        default: 120.618273
      },
      zoom: {
        type: [Number],
        default: 17
      },
    },
    data() {
      return {
        isMarker: false,
        map: '',
        geometries: [],
        jkLayer: '',
        list: [
          {lat: 31.526454, lng: 120.615790, address: '康居一区2排3栋'},
          {lat: 31.526458, lng: 120.615538, address: '康居一区2排5栋'},
          {lat: 31.526692, lng: 120.615050, address: '康居一区3排8栋'},
          {lat: 31.526696, lng: 120.614659, address: '康居一区3排11栋'},
          {lat: 31.526870, lng: 120.615801, address: '康居一区4排3栋'},
          {lat: 31.526879, lng: 120.615292, address: '康居一区4排6栋'},
          {lat: 31.526898, lng: 120.614825, address: '康居一区4排10栋'},
          {lat: 31.527090, lng: 120.614948, address: '康居一区5排9栋'},
          {lat: 31.527048, lng: 120.614181, address: '康居一区5排14栋'},
          {lat: 31.527684, lng: 120.614943, address: '康居一区7排8栋'},
          {lat: 31.527894, lng: 120.615104, address: '康居一区8排7栋'},
          {lat: 31.525704, lng: 120.619304, address: '锦峰新村1排4栋'},
          {lat: 31.525718, lng: 120.619031, address: '锦峰新村1排6栋'},
          {lat: 31.526353, lng: 120.618800, address: '锦峰新村4排8栋'},
          {lat: 31.526559, lng: 120.619363, address: '锦峰新村5排4栋'},
          {lat: 31.526559, lng: 120.619229, address: '锦峰新村5排5栋'},
          {lat: 31.526541, lng: 120.619084, address: '锦峰新村5排6栋'},
          {lat: 31.526550, lng: 120.618945, address: '锦峰新村5排7栋'},
          {lat: 31.526550, lng: 120.618816, address: '锦峰新村5排8栋'},
          {lat: 31.526541, lng: 120.617802, address: '锦峰新村5排14栋'},
        ],
        list2: [
          {lat: 31.526450, lng: 120.615750, address: '康居一区2排3栋'},
          {lat: 31.526454, lng: 120.615518, address: '康居一区2排5栋'},
          {lat: 31.526688, lng: 120.615030, address: '康居一区3排8栋'},
          {lat: 31.526692, lng: 120.614639, address: '康居一区3排11栋'},
          {lat: 31.526865, lng: 120.615826, address: '康居一区4排3栋'},
          {lat: 31.526876, lng: 120.615272, address: '康居一区4排6栋'},
          {lat: 31.526895, lng: 120.614825, address: '康居一区4排10栋'},
          {lat: 31.527087, lng: 120.614928, address: '康居一区5排9栋'},
          {lat: 31.527042, lng: 120.614151, address: '康居一区5排14栋'},
          {lat: 31.527680, lng: 120.614933, address: '康居一区7排8栋'},
          {lat: 31.527890, lng: 120.615134, address: '康居一区8排7栋'},
          {lat: 31.525700, lng: 120.619334, address: '锦峰新村1排4栋'},
          {lat: 31.525714, lng: 120.619041, address: '锦峰新村1排6栋'},
          {lat: 31.526348, lng: 120.618840, address: '锦峰新村4排8栋'},
          {lat: 31.526553, lng: 120.619323, address: '锦峰新村5排4栋'},
          {lat: 31.526554, lng: 120.619249, address: '锦峰新村5排5栋'},
          {lat: 31.526537, lng: 120.619044, address: '锦峰新村5排6栋'},
          {lat: 31.526545, lng: 120.618915, address: '锦峰新村5排7栋'},
          {lat: 31.526546, lng: 120.618806, address: '锦峰新村5排8栋'},
          {lat: 31.526537, lng: 120.617842, address: '锦峰新村5排14栋'},
        ],
        ryList: [
          {name: '濮洪生', lat: 31.52682665, lng: 120.61791113},
          {name: '马义珍', lat: 31.54637836, lng: 120.60506143},
          {name: '谈阿彩', lat: 31.54421479, lng: 120.60679858},
          {name: '华柏元', lat: 31.54528427, lng: 120.60660469},
          {name: '徐长生', lat: 31.530236, lng: 120.615581},
        ],
        showFlag: false,
        flag: 1,//燃气烟感
        detail: {},
        windowTitle: ''
      }
    },
    mounted() {
      let that = this
      const center = new TMap.LatLng(this.latitude, this.longitude);

      this.$nextTick(() => {
        //定义map变量，调用 TMap.Map() 构造函数创建地图
        const map = new TMap.Map('mapScreen2', {
          center: center,//设置地图中心点坐标
          zoom: this.zoom,   //设置地图缩放级别
          pitch: 55,  //设置俯仰角
          rotation: 30,    //设置地图旋转角度
          mapStyleId: 'style1',
        });
        // 隐藏控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM) // 比例尺控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE) // 比例尺控件
        map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION) // 旋转控件
        // 去除logo及水印，开发文档中也有去除LOGO的方法，但不能去除左下角信息
        var a = document.querySelector('canvas+div:last-child')
        a.style.display = 'none'

        let arr = [], brr = [], crr = []
        this.list.map((item, index) => {
          item.dl = this.random(90, 100)
          arr.push(
            {
              "id": index,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle',  //指定样式id
              "position": new TMap.LatLng(item.lat, item.lng),  //点标记坐标位置
              "data": item
            }
          )
        })
        this.ryList.map((item2, index2) => {
          item2.dl = this.random(90, 100)
          brr.push(
            {
              "id": index2,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle',  //指定样式id
              "position": new TMap.LatLng(item2.lat, item2.lng),  //点标记坐标位置
              "data": item2
            }
          )
        })
        this.list2.map((item3, index3) => {
          item3.dl = this.random(90, 100)
          crr.push(
            {
              "id": index3,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
              "styleId": 'myStyle',  //指定样式id
              "position": new TMap.LatLng(item3.lat, item3.lng),  //点标记坐标位置
              "data": item3
            }
          )
        })
        //燃气
        var markerLayer1 = new TMap.MultiMarker({
          map: map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle": new TMap.MarkerStyle({
              "width": 32,  // 点标记样式宽度（像素）
              "height": 32, // 点标记样式高度（像素）
              "src": img1,  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            })
          },
          //点标记数据数组
          geometries: arr
        });
        //烟感
        var markerLayer2 = new TMap.MultiMarker({
          map: map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle": new TMap.MarkerStyle({
              "width": 32,  // 点标记样式宽度（像素）
              "height": 32, // 点标记样式高度（像素）
              "src": img2,  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            })
          },
          //点标记数据数组
          geometries: crr
        });
        //一键告警
        var markerLayer3 = new TMap.MultiMarker({
          map: map,  //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle": new TMap.MarkerStyle({
              "width": 32,  // 点标记样式宽度（像素）
              "height": 32, // 点标记样式高度（像素）
              "src": img3,  //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            })
          },
          //点标记数据数组
          geometries: brr
        });

        this.map = map

        this.map.on('click', (e) => {
          console.log('点击地图', e)
        })

        markerLayer1.on("click", this.fun1)
        markerLayer2.on("click", this.fun2)
        markerLayer3.on("click", this.fun3)
      })
    },
    methods: {
      // 设置中心点
      setCenter(lat, lng) {
        let that = this
        console.log("更新中心点到:" + lat + "," + lng)
        const center = new TMap.LatLng(lat, lng);
        that.map.setCenter(center);
      },
      fun1(res) {
        this.windowTitle = '燃气设备'
        this.flag = 1
        this.showFlag = true
        this.detail = res.geometry.data
      },
      fun2(res) {
        this.windowTitle = '烟感设备'
        this.flag = 1
        this.showFlag = true
        this.detail = res.geometry.data
      },
      fun3(res) {
        this.windowTitle = '一键告警设备'
        this.flag = 2
        this.showFlag = true
        this.detail = res.geometry.data
      },
      random(lower, upper) {
        // 包括下线数字（lower）也包括上限数字（upper）
        return Math.floor(Math.random() * (upper - lower + 1)) + lower;
      },
      closeWin() {
        this.showFlag = false
        this.flag = 1
      }
    }
  }
</script>

<style scoped lang="less">
  .map {
    height: 100%;
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .openWin {
    padding: 10px 15px;
    position: absolute;
    top: 5%;
    right: 5%;
    z-index: 1000;
    color: #fff;
    background-color: rgba(3, 28, 82, 0.7);
    border-radius: 4px;
    font-size: 16px;
    border: 1px solid #0A205C;
    min-width: 250px;

    .iconBox {
      width: 100%;
      color: #ffffff;
      display: flex;
      align-items: center;

      #close {
        text-align: right;
        font-size: 20px;
        flex-grow: 1;
      }

      .title {
        text-align: left;
        font-size: 18px;
      }
    }

    .box {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .label {
      display: inline-block;
      line-height: 28px;
    }
  }
</style>
